import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function ManageArea(props: any) {
  let myProps = {
    infoArr: [],
    setInfoArr: (inData: any) => { },
    ListComponentRef: null,
    go_select_write_by_ajax: (inData: any) => { },
    ...props
  };
  let ListComponentRef = myProps.ListComponentRef;
  let select_subject_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });

  const [cate_listOpt, set_cate_listOpt] = useState<any>({
    s_subject: "",
    s_category_seq: "",
    s_sort1_seq: "",
    s_sort2_seq: "",
    s_sort3_seq: "",
  });

  const [change_key_val, set_change_key_val] = useState<any>({
    key: "",
    val: "",
    is_select: false,
  });
  const [select_select_val_arr, set_select_val_arr] = useState<any[]>([]);
  const [category_arr, set_category_arr] = useState<any>([]);
  const [sort1_arr, set_sort1_arr] = useState<any>([]);
  const [sort2_arr, set_sort2_arr] = useState<any>([]);
  const [sort3_arr, set_sort3_arr] = useState<any>([]);

  useEffect(() => {

  }, []);

  const get_textbook_sort_by_ajax = (inData: any) => {
    let opt_obj = {
      s_type: "sort1",
      s_par_id: "mtextbook_sort",
      s_par_seq: "",
      ...inData
    };

    let formJsonData = {
      s_type: opt_obj.s_type,
      s_par_id: opt_obj.s_par_id,
      s_par_seq: opt_obj.s_par_seq,
      order_id: "a_order_num",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/sort/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.s_type == "sort1") {
            set_sort1_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "sort2") {
            set_sort2_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "sort3") {
            set_sort3_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "category") {
            set_category_arr(response.data["data"]["info_arr"]);
          }
        }
      });
  };

  const on_change_cate_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;

    let change_list_opt: any = {
      ...cate_listOpt,
    };
    change_list_opt[name] = value;
    if (name == "s_subject") {
      change_list_opt["s_sort1_seq"] = "";
      change_list_opt["s_sort2_seq"] = "";
      change_list_opt["s_sort3_seq"] = "";
      set_sort1_arr([]);
      set_sort2_arr([]);
      set_sort3_arr([]);
      if (strFunc.is_empty(value)) {
        set_category_arr([]);
      } else {
        get_textbook_sort_by_ajax({ s_type: "category", s_par_id:"subject",s_par_seq: value });
      }
    } else if (name == "s_category_seq") {
      change_list_opt["s_sort1_seq"] = "";
      change_list_opt["s_sort2_seq"] = "";
      change_list_opt["s_sort3_seq"] = "";
      set_sort2_arr([]);
      set_sort3_arr([]);
      if (strFunc.is_empty(value)) {
        set_sort1_arr([]);
      } else {
        get_textbook_sort_by_ajax({ s_type: "sort1", s_par_seq: value });
      }
    } else if (name == "s_sort1_seq") {
      change_list_opt["s_sort2_seq"] = "";
      change_list_opt["s_sort3_seq"] = "";
      set_sort3_arr([]);
      if (strFunc.is_empty(value)) {
        set_sort2_arr([]);
      } else {
        get_textbook_sort_by_ajax({ s_type: "sort2", s_par_seq: value });
      }
    } else if (name == "s_sort2_seq") {
      change_list_opt["s_sort3_seq"] = "";
      if (strFunc.is_empty(value)) {
        set_sort3_arr([]);
      } else {
        get_textbook_sort_by_ajax({ s_type: "sort3", s_par_seq: value });
      }
    }
    set_cate_listOpt(change_list_opt);
  };

  const on_change_multy_change = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let is_select = false;
    if (value == "a_subject") {
      set_select_val_arr(select_subject_arr);
      is_select = true;
    }
    set_change_key_val({
      ...change_key_val,
      key: value,
      val: "",
      is_select: is_select
    });
  };

  const on_change_multy_val = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    set_change_key_val({
      ...change_key_val,
      val: value
    });
  };

  const select_change_by_change_val = () => {
    let select_info_arr = [];
    if (ListComponentRef.current) {
      select_info_arr = ListComponentRef.current.getSelectedRows();
    }
    if (select_info_arr.length == 0) {
      alert("선택된 도서가 없습니다.");
      return false;
    }

    if (change_key_val.key == "") {
      alert("변경할 항목을 선택해주세요.");
      return false;
    }

    let change_info_arr: any[] = myProps.infoArr;
    for (let info_i = 0; info_i < change_info_arr.length; info_i++) {
      let info = change_info_arr[info_i];
      for (let i = 0; i < select_info_arr.length; i++) {
        let select_info = select_info_arr[i];
        if (info.a_seq == select_info.a_seq) {
          change_info_arr[info_i][change_key_val.key] = change_key_val.val;

          if (change_key_val.key == "a_category_seq") {
            change_info_arr[info_i]["a_subject"] = cate_listOpt.s_subject;
            change_info_arr[info_i]["a_category_seq"] = cate_listOpt.s_category_seq;
            change_info_arr[info_i]["bcategory_title"] = category_arr.find((item: any) => item.a_seq == cate_listOpt.s_category_seq)?.a_title || "";
            change_info_arr[info_i]["a_sort1_seq"] = cate_listOpt.s_sort1_seq;
            change_info_arr[info_i]["bsort1_title"] = sort1_arr.find((item: any) => item.a_seq == cate_listOpt.s_sort1_seq)?.a_title || "";
            change_info_arr[info_i]["a_sort2_seq"] = cate_listOpt.s_sort2_seq;
            change_info_arr[info_i]["bsort2_title"] = sort2_arr.find((item: any) => item.a_seq == cate_listOpt.s_sort2_seq)?.a_title || "";
            change_info_arr[info_i]["a_sort3_seq"] = cate_listOpt.s_sort3_seq;
            change_info_arr[info_i]["bsort3_title"] = sort3_arr.find((item: any) => item.a_seq == cate_listOpt.s_sort3_seq)?.a_title || "";
          }
        }
      }
    }

    myProps.setInfoArr(change_info_arr);
    if (ListComponentRef.current) {
      ListComponentRef.current.setInfoArr(change_info_arr);
    }
  };

  return (
    <div className="search-box">
      <select name="change_key" value={change_key_val.key} className="search-input"
        onChange={on_change_multy_change} style={{ width: '100px' }}>
        <option value="">선택</option>
        <option value="a_subject">과목</option>
        <option value="a_category_seq">카테고리</option>
      </select>
      {
        change_key_val.is_select ?
          <select name="change_val" value={change_key_val.val} className="search-input"
            onChange={on_change_multy_val} style={{ width: '100px' }} >
            <option value="">선택</option>
            {select_select_val_arr.map((item: any, idx: number) =>
              <option key={idx} value={item.value}>{item.text}</option>
            )}
          </select>
          :
          <input type="text" name="change_val" value={change_key_val.val} className="search-input"
            onChange={on_change_multy_val} style={{ width: '100px' }} />
      }
      {change_key_val.key == "a_category_seq" && <>
        <select name="s_subject" value={cate_listOpt.s_subject} className="search-input"
          onChange={on_change_cate_input} style={{ width: '100px' }}>
          <option value="">과목</option>
          {select_subject_arr.map((item: any, index: number) => (
            <option key={index} value={item.value}>{item.text}</option>
          ))}
        </select>
        <select name="s_category_seq" value={cate_listOpt.s_category_seq} className="search-input"
          onChange={on_change_cate_input} style={{ width: '100px' }}>
          <option value="">카테고리</option>
          {category_arr.map((item: any, index: number) => (
            <option key={index} value={item.a_seq}>{item.a_title}</option>
          ))}
        </select>
        <select name="s_sort1_seq" value={cate_listOpt.s_sort1_seq} className="search-input ml-1"
          onChange={on_change_cate_input} style={{ width: '100px' }}>
          <option value="">대분류</option>
          {sort1_arr.map((item: any, index: number) => (
            <option key={index} value={item.a_seq}>{item.a_title}</option>
          ))}
        </select>
        <select name="s_sort2_seq" value={cate_listOpt.s_sort2_seq} className="search-input ml-1"
          onChange={on_change_cate_input} style={{ width: '100px' }}>
          <option value="">중분류</option>
          {sort2_arr.map((item: any, index: number) => (
            <option key={index} value={item.a_seq}>{item.a_title}</option>
          ))}
        </select>
        <select name="s_sort3_seq" value={cate_listOpt.s_sort3_seq} className="search-input ml-1"
          onChange={on_change_cate_input} style={{ width: '100px' }}>
          <option value="">소분류</option>
          {sort3_arr.map((item: any, index: number) => (
            <option key={index} value={item.a_seq}>{item.a_title}</option>
          ))}
        </select>
      </>}
      <button className='btn btn-dark ml-1' onClick={() => { select_change_by_change_val(); }}>선택수정</button>
      <button className='btn btn-sky ml-1' onClick={() => { myProps.go_select_write_by_ajax({}); }}>선택저장</button>
    </div>
  );
};
export default ManageArea;